<template>
  <b-card
    title="Buchungen"
    style="overflow-x: scroll"
  >
    <div>
      <!-- {{ orders }} -->
      <b-table-simple
        ref="table"
        hover
        outlined
        caption-top
        responsive="true"
        striped
        :items="orders"
        class="rounded-bottom mb-0"
        @row-clicked="onRowClicked"
      >
        <b-thead head-variant="light">
          <b-tr>
            <b-th rowspan="2">
              Nr
            </b-th>
            <b-th rowspan="2">
              Datum
            </b-th>
            <b-th rowspan="2">
              Details
            </b-th>
            <b-th rowspan="2">
              Pos
            </b-th>
            <b-th rowspan="2">
              Summe
            </b-th>
            <b-th colspan="7">
              Buchugspositionen
            </b-th>
          </b-tr>
          <b-tr>
            <b-th>Mietstart</b-th>
            <b-th>Mietende</b-th>
            <b-th>Storage</b-th>
            <b-th>Standort</b-th>
            <b-th>Preis</b-th>
            <b-th>Vertrag</b-th>
            <b-th>Ausbuchen</b-th>
          </b-tr>
        </b-thead>
        <b-tbody
          v-for="(order, index) in orders"
          :key="index"
        >
          <b-tr>
            <b-td :rowspan="order.order_items.length + 1">
              {{ order.id }}
            </b-td>
            <b-td :rowspan="order.order_items.length + 1">{{
              getDate(order.orderDate)
            }}</b-td>
            <b-td :rowspan="order.order_items.length + 1">{{
              order.orderDetails
            }}</b-td>
            <b-td :rowspan="order.order_items.length + 1">{{
              order.order_items.length
            }}</b-td>
            <b-td
              variant="success"
              :rowspan="order.order_items.length + 1"
            ><strong>{{ getTotalSumByOrderId(order.id) }} €</strong></b-td>
          </b-tr>
          <b-tr
            v-for="(item, itemIndex) in order.order_items"
            :key="itemIndex"
          >
            <b-td>{{ getFormattedDate(item.rentStart) }}</b-td>
            <b-td
              :variant="isRentActive(item.rentEnd)"
            >{{ item.rentEnd ? getFormattedDate(item.rentEnd) : 'Unbefristet' }}
            </b-td>
            <b-td>{{ storagesById(item.storage).name }}</b-td>
            <b-td>{{ storagesById(item.storage).location.name }}</b-td>
            <b-td><b-badge variant="success">
              {{ item.price }} €
            </b-badge></b-td>
            <b-td class="text-center">
              <div
                v-if="item.zohoDocumentId"
                class="d-flex align-items-center justify-content-center"
                style="gap: 0.5rem;"
              >
                <b-button
                  variant="primary"
                  size="sm"
                  class="btn-icon rounded"
                  title="Vertrag Vorschau"
                  @click="showQuickView(item.zohoDocumentId)"
                >
                  <feather-icon
                    icon="EyeIcon"
                    size="15"
                  />
                </b-button>
                <b-button
                  variant="primary"
                  size="sm"
                  class="btn-icon rounded"
                  :href="getZohoPortalUrl(item.zohoDocumentId)"
                  target="_blank"
                  title="In Zoho Sign öffnen"
                >
                  <feather-icon
                    icon="ExternalLinkIcon"
                    size="15"
                  />
                </b-button>
              </div>
              <span
                v-else-if="item.isLegacyImport && item.legacyContractAvailable"
                class="text-muted small"
                title="Bestands-Auftrag: Original-Vertrag liegt als Scan in der Anlagen-Section weiter unten."
              >
                <feather-icon
                  icon="PaperclipIcon"
                  size="14"
                />
                Siehe Anlagen
              </span>
              <span
                v-else
                class="text-muted"
              >-</span>
            </b-td>
            <b-td class="text-center">
              <b-button
                v-if="!item.moveOutDate"
                variant="outline-danger"
                size="sm"
                title="Ausbuchen"
                @click="showMoveOutModal(item)"
              >
                <feather-icon
                  icon="LogOutIcon"
                  size="16"
                />
              </b-button>
              <small
                v-else
                class="text-muted"
              >
                {{ getFormattedDate(item.moveOutDate) }}
              </small>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-modal
        ref="modal-moveout"
        cancel-variant="outline-secondary"
        ok-title="Ausbuchen"
        cancel-title="Schließen"
        centered
        title="Ausbuchen"
        @ok="moveOutAction"
        @hide="hideMoveOutModal"
      >
        <b-form>
          <!-- {{ moveOutItem }} -->
          <p>
            Lager <strong>{{ storage.name }}</strong> in
            <strong>{{ storage.location.name }}</strong> wirklich ausbuchen?
          </p>

          <b-form-group>
            <label for="description">Beschreibung (optional)</label>
            <b-form-textarea
              id="textarea-default"
              v-model="moveOutItem.moveOutDescription"
              placeholder=""
              rows="2"
            />
          </b-form-group>
          <b-form-group>
            <label for="date">Datum</label>
            <flatpickr
              v-model="moveOutItem.moveOutDate"
              class="form-control"
              :config="{
                enableTime: true,
                altInput: true,
                altFormat: 'd-M-Y - H:i \\U\\h\\r',
                dateFormat: 'Z',
                locale: {
                  firstDayOfWeek: 1, // start week on Monday
                },
                time_24hr: true,
                // defaultDate: '24:00',
                defaultHour: '00',
                defaultMinute: '00',
              }"
            />
          </b-form-group>
        </b-form>
      </b-modal>
      <!-- Zoho Document QuickView Modal -->
      <zoho-document-quick-view ref="zohoQuickView" />
    </div>
  </b-card>
</template>
<script>
import moment from 'moment'
import {
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTd,
  BTbody,
  BTfoot,
  BCard,
  BBadge,
  BButton,
  BButtonGroup,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import 'flatpickr/dist/flatpickr.min.css'
import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de'
import Vueflatpickr from 'vue-flatpickr-component'
import helper from '@/helper/helper'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ZohoDocumentQuickView from './ZohoDocumentQuickView.vue'

flatpickr.localize(German)

export default {
  components: {
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    BCard,
    BBadge,
    BButton,
    BButtonGroup,
    BModal,
    VBModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    flatpickr: Vueflatpickr,
    ZohoDocumentQuickView,
  },
  // props: ['orders'],
  setup() {
    const { getFormattedDate } = helper()

    return {
      getFormattedDate,
    }
  },
  data() {
    return {
      storage: {
        name: '',
        location: {},
      },
      moveOutItem: {},
    }
  },
  computed: {
    ordersWithZohoData() {
      const baseOrders = this.$store.getters
        .orderByCustomerId(Number(this.$route.params.id))
        .sort((a, b) => b.id - a.id)

      const zohoContracts = this.$store.getters['zohoContract/zohoContracts'] || []

      // For legacy-import orders we surface a paperclip hint when the customer
      // actually has a contract scan attached. Without a hard link between
      // attachment and order_item, presence at the customer level is the best
      // signal available.
      const customerAttachments = this.$store.getters.attachementsEntries || []
      const customerId = Number(this.$route.params.id)
      const legacyContractAvailable = customerAttachments.some(a => {
        const linkedCustomer = a.customer?.id || a.customer
        const typeLabel = a.attachment_type?.attachmentType || ''
        return linkedCustomer === customerId && /vertrag/i.test(typeLabel)
      })

      // Enrich order items with Zoho contract data
      return baseOrders.map(order => ({
        ...order,
        order_items: order.order_items ? order.order_items.map(item => {
          // Legacy-import orders have no digital contract by design — the
          // signed original lives as a scan in the customer's attachments.
          // Skip the storage-based fallback matcher entirely to avoid
          // surfacing a previous tenant's Zoho contract for the same container.
          if (order.isLegacyImport) {
            return {
              ...item,
              isLegacyImport: true,
              legacyContractAvailable,
            }
          }
          // Find matching ZohoContract by orderItem ID or storage ID
          const matchingContract = zohoContracts.find(contract => {
            // Try to match by orderItem ID first
            if (contract.orderItem === item.id || contract.orderItem?.id === item.id) {
              return true
            }
            // Fallback: match by storage ID (for older data)
            if (contract.storage === item.storage || contract.storage?.id === item.storage) {
              return true
            }
            return false
          })

          return {
            ...item,
            zohoDocumentId: matchingContract?.zohoDocumentId || item.zohoDocumentId,
            zohoSignStatus: matchingContract?.zohoSignStatus || item.zohoSignStatus,
            zohoSignUrl: matchingContract?.zohoSignUrl || item.zohoSignUrl,
            zohoRequestId: matchingContract?.zohoRequestId || item.zohoRequestId,
            zohoSentDate: matchingContract?.zohoSentDate || item.zohoSentDate,
            zohoRecipientEmail: matchingContract?.zohoRecipientEmail || item.zohoRecipientEmail,
          }
        }) : []
      }))
    },

    orders() {
      return this.ordersWithZohoData
    },

    currentRouteName() {
      return this.$route.name
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format('DD.MM.YYYY - H:mm:ss')
    },
    storagesById(id) {
      return this.$store.getters.storageById(id)
    },
    getTotalSumByOrderId(id) {
      return this.$store.getters.getTotalSumByOrderId(Number(id))
    },
    isRentActive(rentEndDate) {
      if (!rentEndDate) return 'success'
      return Date.now() < new Date(rentEndDate).getTime() ? 'success' : 'danger'
    },
    onRowClicked(item) {
      this.$router.push(`/orders-view/${item.id}`)
    },
    showMoveOutModal(item) {
      // Deep clone to avoid modifying original data
      this.moveOutItem = JSON.parse(JSON.stringify(item))
      // Set default date to current date/time if not already set
      if (!this.moveOutItem.moveOutDate) {
        this.moveOutItem.moveOutDate = new Date().toISOString()
      }
      this.$refs['modal-moveout'].show()
      this.storage = this.storagesById(this.moveOutItem.storage)
    },
    moveOutAction() {
      // Show loading state
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Wird ausgebucht...',
          icon: 'ClockIcon',
          variant: 'info',
        },
      })

      this.$store
        .dispatch('updateOrderItem', this.moveOutItem)
        .then(response => {
          if (response.moveOutDate !== null) {
            // Success notification
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erfolgreich ausgebucht',
                text: `${this.storage.name} wurde erfolgreich ausgebucht.`,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })

            // Refresh data
            this.$store.dispatch('getOrderEntries')
            this.$store.dispatch('getStorageEntries')
            this.$store.dispatch('getOrderItemsEntries')

            // Close modal
            this.$refs['modal-moveout'].hide()
          }
        })
        .catch(error => {
          // Error notification
          console.error('Error during moveOut:', error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Fehler beim Ausbuchen',
              text: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        })
    },
    showQuickView(documentId) {
      this.$refs.zohoQuickView.show(documentId)
    },
    hideMoveOutModal() {
      // Reset moveOutItem when modal is closed
      this.moveOutItem = {}
    },
    getZohoPortalUrl(documentId) {
      if (!documentId) return null
      const ZOHO_ACCOUNT_ID = '20103098086'
      return `https://sign.zoho.eu/zs/${ZOHO_ACCOUNT_ID}#/request/details/${documentId}`
    },
    getZohoStatusLabel(status) {
      const labels = {
        not_sent: 'Nicht versendet',
        sent: 'Versendet',
        viewed: 'Angesehen',
        signed: 'Unterzeichnet',
        declined: 'Abgelehnt',
        expired: 'Abgelaufen',
      }
      return labels[status] || '-'
    },
    getZohoStatusVariant(status) {
      const variants = {
        not_sent: 'secondary',
        sent: 'info',
        viewed: 'warning',
        signed: 'success',
        declined: 'danger',
        expired: 'dark',
      }
      return variants[status] || 'secondary'
    },
    getZohoStatusIcon(status) {
      const icons = {
        not_sent: 'MailIcon',
        sent: 'SendIcon',
        viewed: 'EyeIcon',
        signed: 'CheckCircleIcon',
        declined: 'XCircleIcon',
        expired: 'ClockIcon',
      }
      return icons[status] || 'FileIcon'
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

// Contract status icons with colors
.status-icon-sent {
  color: #17a2b8 !important; // info blue
}

.status-icon-viewed {
  color: #ffc107 !important; // warning yellow
}

.status-icon-signed {
  color: #28a745 !important; // success green
}

.status-icon-declined {
  color: #dc3545 !important; // danger red
}

.status-icon-expired {
  color: #6c757d !important; // dark gray
}

.status-icon-not_sent {
  color: #6c757d !important; // secondary gray
}

// Contract link styling
.contract-link {
  color: #007bff !important;
  text-decoration: none;

  &:hover {
    color: #0056b3 !important;
    transform: scale(1.1);
    transition: all 0.2s ease;
  }
}

</style>
